/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.filter('validation_status', () => (function(input) {
    const validation_status = {
        request: 'Demande envoyée',
        denied:  'Étape refusée',
        valid:   'Étape validée'
    };
    if (validation_status[input] != null) { return validation_status[input]; } else { return input; }
}));
